import { VisualisationGatewayService } from 'CommonData/services/visualisationGateway.service';
import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';
const QRCode = require('easyqrcodejs');

export class VirtualPlatforms {
    private static deviceSupportsAR: boolean = false;
    private static arModelIsOutdated: boolean = true;
    private static modelViewerElement: any = document.querySelector('.js-model-viewer');
    private static qrCodeContainer: HTMLDivElement = document.querySelector('.js-qr-code-container');
    private static reloadARModelBtn: HTMLDivElement = document.querySelector('.js-model-reload');
    private static currentSceneTexture: any;

    public static init() {
        this.initEvents();

        // By default, just load a QR Code for the current scene
        this.setQRCodeToCurrentScene();

        // Yep this is shit but there really is not other way to do this efficiently
        // Let the DOM load
        window.setTimeout(() => {
            const shadowRoot: any = this.modelViewerElement.shadowRoot;

            if (this.modelViewerElement && shadowRoot) {
                const arButtonElement: HTMLElement = shadowRoot.querySelector('.ar-button');
                this.deviceSupportsAR = arButtonElement && arButtonElement.classList.contains('enabled');
                console.log(`Marshalls 3D Viewer AR Supported:${this.deviceSupportsAR}`);

                if (this.deviceSupportsAR) {
                    this.qrCodeContainer.classList.add('hidden');
                    this.modelViewerElement.classList.remove('hidden');
                }
            }
        }, 1000);
    }

    private static initEvents() {
        this.reloadARModelBtn?.addEventListener('click', () => {
            this.updateVirtualPlatformContent();
        });

        // For WEBXR AR sessions we need to stop and start the main scene renderer
        // when an AR session starts otherwise it kills the browser
        this.modelViewerElement.addEventListener('ar-status', (e: any) => {
            switch (e.detail.status) {
                case "session-started":
                case "object-placed":
                    LayingPatternViewer.stopRenderer();
                    break;
                default:
                    LayingPatternViewer.startRenderer();
                    break;
            }
        });
    }

    public static updateVirtualPlatformContent() {
        this.currentSceneTexture = LayingPatternViewer.getCurrentTexture();

        if (this.deviceSupportsAR && this.arModelIsOutdated) {
            this.loadARModel(this.currentSceneTexture.ProductTextureKey, this.currentSceneTexture.JointTextureKey, this.currentSceneTexture.MaskId, this.currentSceneTexture.PatternId, this.currentSceneTexture.JointWidthMM);
            this.arModelIsOutdated = false;
        }
    }

    public static expireCurrentARModel() {
        this.arModelIsOutdated = true;
        this.reloadARModelBtn.classList.remove('hidden');
    }



    private static setQRCodeToCurrentScene() {
        // To Do, get current scene favs Url
        const currentFavsUrl: string = window.location.toString();
        new QRCode(this.qrCodeContainer, {
            text: currentFavsUrl,
            width: 100,
            height: 100,
        });
    }

    private static async loadARModel(materialTextureKey: string, jointKey: string, maskId: number, patternId: number, jointWidth: number) {
        await VisualisationGatewayService.postJitarModel(materialTextureKey, jointKey, maskId, patternId, jointWidth).then(
            (response) => {
                if (response && response.data && this.modelViewerElement) {
                    this.modelViewerElement.setAttribute('src', response.data);
                    this.reloadARModelBtn.classList.add('hidden');
                }
            },
            () => {
                // Something has gone wrong so for now just set the src to the NoModel.glb default
                this.loadDefaultARModel();
                this.reloadARModelBtn.classList.remove('hidden');
            }
        );
    }

    private static loadDefaultARModel() {
        this.modelViewerElement.setAttribute('src', 'https://media.marshalls.co.uk/image/upload/VisualiserMaterials/_JITARModels/NoModel.glb');
    }
}